import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, YELLOW_600, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { getStatusCardTimerTextStyles } from './StatusCardTimerTextStyles';
export var StatusCardTimerText = props => {
  var id = props.id,
    _props$startTime = props.startTime,
    startTime = _props$startTime === void 0 ? 0 : _props$startTime,
    _props$interval = props.interval,
    interval = _props$interval === void 0 ? 1000 : _props$interval,
    _props$prefixText = props.prefixText,
    prefixText = _props$prefixText === void 0 ? '' : _props$prefixText,
    _props$postFixText = props.postFixText,
    postFixText = _props$postFixText === void 0 ? '' : _props$postFixText,
    _props$timerTextColor = props.timerTextColor,
    timerTextColor = _props$timerTextColor === void 0 ? YELLOW_600 : _props$timerTextColor,
    onTimerEnd = props.onTimerEnd,
    onUserAction = props.onUserAction,
    testID = props.testID,
    style = props.style,
    _props$unit = props.unit,
    unit = _props$unit === void 0 ? 'second' : _props$unit;
  var _useState = useState(startTime),
    countDownTime = _useState[0],
    setCountDownTime = _useState[1];
  var statusCardTimerTextStyles = getStatusCardTimerTextStyles();
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  useEffect(() => {
    var timer = setInterval(() => {
      setCountDownTime(prev => {
        var newTime = prev - 1;
        if (newTime === 0) {
          clearInterval(timer);
          onTimerEnd && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onTimerEnd)));
        }
        return newTime;
      });
    }, interval);
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);
  var formatTime = time => {
    var _a;
    var hours, minutes, seconds, minutesOnly, secondsOnly;
    switch (unit) {
      case 'hour':
        hours = Math.floor(time / 3600);
        minutes = Math.floor(time % 3600 / 60);
        seconds = time % 60;
        return (hours === null || hours === void 0 ? void 0 : hours.toString().padStart(2, '0')) + ":" + minutes.toString().padStart(2, '0') + ":" + (seconds === null || seconds === void 0 ? void 0 : seconds.toString().padStart(2, '0'));
      case 'minute':
        minutesOnly = Math.floor(time / 60);
        secondsOnly = time % 60;
        return (minutesOnly === null || minutesOnly === void 0 ? void 0 : minutesOnly.toString().padStart(2, '0')) + ":" + secondsOnly.toString().padStart(2, '0');
      case 'second':
        return "" + ((_a = time === null || time === void 0 ? void 0 : time.toString) === null || _a === void 0 ? void 0 : _a.call(time).padStart(2, '0'));
      default:
        throw new Error("Invalid unit: " + unit);
    }
  };
  var timerText = prefixText + " " + formatTime(countDownTime) + " " + postFixText;
  return _jsx(_Fragment, {
    children: !!countDownTime && _jsx(Typography, Object.assign({
      type: isLargeScreen ? 'body-single-line-md-bold' : 'body-single-line-sm-bold',
      color: timerTextColor,
      text: timerText,
      style: [statusCardTimerTextStyles.text, style]
    }, getTestId(testID, 'timerText')))
  });
};